declare global {
  interface Window {
    isKenttaNativeApp?: boolean
    ReactNativeWebView?: {
      postMessage(message: string): void
    }
  }
}

export type NfcTagData = {
  tagId: string
  busNumber?: string
  location?: string
  tagType?: string
  rawPayload: string
}

export type NfcScanResult =
  | { type: 'nfc-scan-result'; data: NfcTagData }
  | { type: 'nfc-scan-error'; error: string }
  | { type: 'nfc-scan-cancelled' }
  | { type: 'nfc-not-supported' }

export const NFC_SCAN_TIMEOUT_MS = 60000

let nfcScanSequence = 0

export function isNativeApp(): boolean {
  return !!window.isKenttaNativeApp
}

export function requestNfcScan(signal?: AbortSignal): Promise<NfcScanResult> {
  if (!isNativeApp()) {
    return Promise.resolve({ type: 'nfc-not-supported' })
  }

  if (signal?.aborted) {
    return Promise.resolve({ type: 'nfc-scan-cancelled' })
  }

  return new Promise((resolve) => {
    let settled = false
    const scanId = ++nfcScanSequence

    const postMessage = (type: 'nfc-scan-request' | 'nfc-scan-cancel') => {
      window.ReactNativeWebView?.postMessage(JSON.stringify({ type, scanId }))
    }

    const finish = (result: NfcScanResult) => {
      if (settled) {
        return
      }
      settled = true
      clearTimeout(timeout)
      window.removeEventListener('kentta-native-message', handler)
      signal?.removeEventListener('abort', handleAbort)
      resolve(result)
    }

    const handler = (event: Event) => {
      const detail = (event as CustomEvent).detail
      if (detail.scanId !== undefined && detail.scanId !== scanId) {
        return
      }
      finish(detail as NfcScanResult)
    }

    const handleAbort = () => {
      postMessage('nfc-scan-cancel')
      finish({ type: 'nfc-scan-cancelled' })
    }

    const timeout = window.setTimeout(() => {
      postMessage('nfc-scan-cancel')
      finish({ type: 'nfc-scan-error', error: 'timeout' })
    }, NFC_SCAN_TIMEOUT_MS)

    window.addEventListener('kentta-native-message', handler)
    signal?.addEventListener('abort', handleAbort)
    postMessage('nfc-scan-request')
  })
}
